import { useTranslation } from 'react-i18next';
import type { OverviewSeats } from '../../types/overviewTypes';
import styles from './SeatsContext.module.css';

interface SeatsContextProps {
  seats: OverviewSeats;
}

/**
 * How many people sit behind the money.
 *
 * Context rather than a KPI, and deliberately given no bar and no target:
 * "we go with the economical part driving the KPIs, not with the seats"
 * (Steffen, 2026-08-20). Called seats, never patients, because a returning
 * patient fills two seats while counting once as a patient.
 */
export const SeatsContext = ({ seats }: SeatsContextProps) => {
  const { t } = useTranslation();

  return (
    <section className={styles.seats}>
      <p className={styles.figures}>
        {t('overview-seats-context', { planned: seats.planned, completed: seats.completed })}
      </p>
      <p className={styles.caveat}>{t('overview-caveat-seats')}</p>
    </section>
  );
};
